export default __webpack_public_path__ + "08652f9b4e0ab32afd089e05f44b406f.png";